import { MessageSquare } from 'lucide-react';
import { useAppSelector } from '@/store/hooks';
import { selectTotalChatUnread } from '../store/chatSelectors';
import { useChatPanelOptional } from '../context/chatPanelContext';

/**
 * Header control: opens the chat panel. Renders nothing if ChatProvider is missing.
 */
export function ChatButton() {
    const panel = useChatPanelOptional();
    const unread = useAppSelector(selectTotalChatUnread);
    const badgeText = unread > 99 ? '99+' : String(unread);

    if (!panel) return null;

    const { togglePanel } = panel;

    return (
        <div className="relative">
            <button
                type="button"
                onClick={togglePanel}
                className="relative rounded-md p-[0.375rem] text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                aria-label={unread > 0 ? `Messages, ${unread} unread` : 'Messages'}
                aria-expanded={panel.isPanelOpen}
                aria-haspopup="dialog"
            >
                <MessageSquare
                    className={`h-[1.25rem] w-[1.25rem] ${unread > 0 ? 'text-foreground' : ''}`}
                    aria-hidden
                />
                {unread > 0 ? (
                    <span className="absolute -right-px -top-px inline-flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-bold tabular-nums leading-none text-white shadow-sm ring-1 ring-card">
                        {badgeText}
                    </span>
                ) : null}
            </button>
        </div>
    );
}
